import { notification } from 'antd'
import { useEffect } from 'react'
import { notificationMounted } from 'src/pages/goldenMay2026/model'

export const useNotificationGoldenMay2026 = () => {
  const [api, contextHolder] = notification.useNotification()

  useEffect(() => {
    notificationMounted({ api, contextHolder })
  }, [])

  return { api, contextHolder }
}
